import type { Tag, Workspace } from '@carboncopyco/types';
import { Checkbox, TextBase } from '@carboncopyco/ui';
import { useMemo } from 'react';
import { type Col, FixedTable } from '../FixedTable';
import { WorkspaceAvatar } from '../Workspaces';
import { useFolderManageAccess } from './FolderManageAccessContext';
import { FolderManageAccessListRowWrapper } from './FolderManageAccessListRowWrapper';
import { FolderManageAccessListSkeleton } from './FolderManageAccessListSkeleton';

export const FolderManageAccessList = () => {
  const { isLoading, list, selectedTags, selectedWorkspaces } =
    useFolderManageAccess();

  const cols = useMemo<Col<Workspace | Tag>[]>(
    () => [
      {
        alignment: 'left',
        title: '',
        width: 40,
        render: (item) => {
          return (
            <div className="flex items-center">
              <Checkbox
                name={item['name'] ?? item['workspaceName']}
                checked={
                  item['name']
                    ? selectedTags.has(item.id)
                    : selectedWorkspaces.has(item.id)
                }
                onChange={(event) => {
                  item['name']
                    ? selectedTags.has(event.target.value)
                      ? selectedTags.delete(event.target.value)
                      : selectedTags.add(event.target.value)
                    : selectedWorkspaces.has(event.target.value)
                      ? selectedWorkspaces.delete(event.target.value)
                      : selectedWorkspaces.add(event.target.value);
                }}
              />
            </div>
          );
        },
      },
      {
        alignment: 'left',
        title: '',
        width: 350,
        maxContentWidth: 350,
        render: (item) =>
          item['name'] ? (
            <div className="flex items-center gap-2.5">
              <div className="text-ds-primary-300 border-ds-primary rounded-full border-2 pt-0.5 w-8 h-8 text-center">
                #
              </div>
              <div className="truncate">
                <TextBase
                  label={item['name']}
                  color="text-ds-natural-600"
                />
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2.5">
              <WorkspaceAvatar
                size="medium"
                workspace={item as Workspace}
              />
              <div className="truncate">
                <TextBase
                  label={item['workspaceName']}
                  color="text-ds-natural-600"
                />
              </div>
            </div>
          ),
      },
    ],
    [selectedWorkspaces, selectedTags]
  );

  return (
    <div className="h-80 overflow-y-auto">
      <FixedTable<Workspace | Tag>
        loaderPlaceholderSpace={0}
        data={list}
        cols={cols}
        loader={<FolderManageAccessListSkeleton count={6} />}
        isLoading={isLoading}
        rowWrapper={FolderManageAccessListRowWrapper}
      />
    </div>
  );
};
